import { render, staticRenderFns } from "./PointListAllHistoryLayout.vue?vue&type=template&id=5f06e1d0&scoped=true&"
import script from "./PointListAllHistoryLayout.vue?vue&type=script&lang=js&"
export * from "./PointListAllHistoryLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06e1d0",
  null
  
)

export default component.exports